<fa-icon
    [class]="isEnabled() ? 'cursor-pointer' : 'cursor-not-allowed text-custom-dark-grey'"
    [class.text-black]="isEnabled() && !isActive()"
    [class.text-custom-blue]="isEnabled() && isActive()"
    [icon]="['fas', 'add']"
    [matTooltip]="tooltipKey() ? (tooltipKey()! | transloco) : ''"
    (click)="onClick($event)" />
